module.exports = __webpack_public_path__ + "img/free.64c79a95.svg";